import React, { useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'

import { IUserData, RightSideNavigation } from '../../../App/Components'
import Spinner from '../../../App/Components/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from '../../../App/Hooks/reduxHooks'
import SecondaryMenuUpdater from '../../../App/SecondaryMenuUpdater'
import { activeEstablishmentSelector } from '../../../Establishment/Store/reducer'
import { getUsers } from '../../../User/Store/actions'
import { RequestsList } from '../RequestsList/RequestsList'
import { ReviewAbsenceRequest } from '../ReviewAbsenceRequest/ReviewAbsenceRequest'
import { getAbsenceRequests, getAbsenceStatistics } from '../Store/Actions'

export const AbsenceRequestsBootstrap = () => {
  const [requestCardModal, setRequestCardModal] = useState<boolean>(false)
  const [activeUser, setActiveUser] = useState<{
    uuid: string
    firstName: string
    lastName: string
  }>()
  const dispatch = useAppDispatch()

  const { users, hasAbsenceRequests, personStatistics } = useAppSelector(
    state => {
      return {
        users: state.users.list,
        hasAbsenceRequests: !!state.hr.absenceRequests.list,
        personStatistics: state.hr.absenceRequests.statistics,
      }
    },
  )

  const establishment = useAppSelector(activeEstablishmentSelector)

  useEffect(() => {
    dispatch(getUsers())
    dispatch(getAbsenceRequests(activeUser))
    dispatch(getAbsenceStatistics())
    SecondaryMenuUpdater.setActive('absence-requests')
  }, [])

  if (
    users === null ||
    !hasAbsenceRequests ||
    typeof personStatistics === 'undefined'
  ) {
    return <Spinner />
  }

  const establishmentUsers = users.filter(
    user => user.establishmentId === establishment.id,
  )

  const sideMenuData: IUserData[] = establishmentUsers.map(user => {
    return {
      uuid: user.uuid,
      avatar: user.avatar,
      firstName: user.firstName,
      lastName: user.lastName,
    }
  })

  return (
    <>
      {sideMenuData &&
      establishment.permissions.includes('absence_requests') ? (
        <RightSideNavigation
          userData={sideMenuData}
          toggleModal={state => setRequestCardModal(state)}
          activeUser={setActiveUser}
        />
      ) : null}
      <Switch>
        <Route
          path="/hr/absence-requests/:absenceRequestId/review"
          component={ReviewAbsenceRequest}
        />
        <Route path="/hr/absence-requests" component={RequestsList} />
      </Switch>
    </>
  )
}
